import { ref } from 'vue'
import { functions, httpsCallable } from '@/firebase/config'

// add admin cloud function
const error = ref(null)

const adminEmail = async (email) => {
  error.value = null
  const addAdminRole = httpsCallable(functions, 'addAdminRole')

  addAdminRole({ email }).then(result => {
    console.log(result)
  }).catch((error) => {
    // Getting the Error details.
    const code = error.code
    const message = error.message
    const details = error.details
    error.value = code + message + details
    // ...
  })
}
// Call updateUser.js
const makeAdmin = () => {
  return { error, adminEmail }
}

export default makeAdmin
